import React from 'react';

import { Block, withBlockRendering } from '../common/Block.jsx';
import { Builder, EditorContainerWrapper, EmptyPlaceholder, PageBottomHiddenDraggable, PageTopHiddenDraggable } from '../layout/Builder.jsx';
import { Meta } from '../common/Cell.jsx';
import { Animation } from '../common/Container.jsx';
import { default as Image, ImageSrcSet, withHoverEffects } from '../common/Image.jsx';
import { default as InventoryHelper } from '../common/Inventory.jsx';
import { ButtonType as InventoryCTAButtonType } from './InventoryCTA.jsx';
import Layout from '../common/Layout.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';
import Url from '../common/Url.jsx';
import Utilities from '../common/Utilities.jsx';

function _InventoryCellContainer(props) {
    const contentConfig = props.contentConfig || {};
    let blocks = [];
    if (contentConfig.desktop && contentConfig.desktop.blocks) {
        blocks = contentConfig.desktop.blocks;
    }
    let builderBlockPropsHandler = (d, blockConfig, parentProps) => {
        let blockProps = Builder.handleBlockProps(d, blockConfig, parentProps);
        Utilities.copyObject(Builder.handleCellBlockProps(d, blockConfig, parentProps), blockProps);
        return blockProps;
    }
    let className = `cell--whitelabel cell--whitelabel--${props.cellType}`;
    let transforms;
    switch (props.cellType) {
        case 'slideshow':
            if (props.v3) {
                className += ' cell--whitelabel--slideshow__inventory';
                transforms = 'c_fit';
            }
            if (props.builder) {
                builderBlockPropsHandler = (d, _, parentProps) => {
                    if (!d.type) {
                        return;
                    }
                    switch (d.type.value) {
                        case Name.Block.Columns:
                            if (d.config && d.config.layout) {
                                let minHeight;
                                if (d.config.layout.minHeight && d.config.layout.minHeight.value && d.config.layout.minHeight.value.length > 0) {
                                    minHeight = `${d.config.layout.minHeight.value}${d.config.layout.minHeight.unit}`;
                                }
                                if (props.v3) {
                                    if (d.config.layout.maxHeight && d.config.layout.maxHeight.value && d.config.layout.maxHeight.value.length > 0) {
                                        return { style: { height: '100%', maxHeight: `${d.config.layout.maxHeight.value}${d.config.layout.maxHeight.unit}`, minHeight } };
                                    }
                                } else if (minHeight) {
                                    return { style: { height: minHeight } };
                                }
                            }
                            break;
                        case Name.Block.Inventory.Cell.Image:
                            return { style: { height: '66%' } };
                        case Name.Block.Inventory.Cell.SlideshowImage:
                            let height = '100%';
                            if (d.config && d.config.layout) {
                                if (d.config.layout.maxHeight && d.config.layout.maxHeight.value && d.config.layout.maxHeight.value.length > 0) {
                                    height = `${d.config.layout.maxHeight.value}${d.config.layout.maxHeight.unit}`;
                                }
                            }
                            return { className: 'builder-block-slider-img', style: { height, maxHeight: '100%' } };
                    }
                }
            }
            className += ' slide__cont';
            break;
        case 'waterfall':
            transforms = 'c_fit';
            break;
    }
    let containerProps;
    if (props.onPageProps) {
        containerProps = props.onPageProps();
    } else if (contentConfig.desktop) {
        containerProps = contentConfig.desktop.page;
    }
    // Block Rendering
    let renderedBlocks = props.onBlockRendering(
        props.pageType,
        blocks,
        (d) => {
            if (!d.type) {
                return;
            }
            switch (d.type.value) {
                case Name.Block.Columns:
                    if (props.cellType == 'slideshow' && props.v3) {
                        return {
                            onLayoutStyleProp: (style, propName, propValue, propUnit) => {
                                switch (propName) {
                                    case 'maxHeight':
                                    case 'minHeight':
                                        if (propUnit == '%' && propValue && propValue.length > 0) {
                                            style[propName] = `${propValue}%`;
                                            return true;
                                        }
                                        break;
                                }
                            }
                        };
                    }
                    break;
                case Name.Block.Inventory.Button.InquireV1:
                case Name.Block.Inventory.Button.InquireV2:
                case Name.Block.Inventory.Button.InquireV3:
                case Name.Block.Inventory.Button.OfferV1:
                case Name.Block.Inventory.Button.OfferV2:
                case Name.Block.Inventory.Button.OfferV3:
                case Name.Block.Inventory.Button.PurchaseV1:
                case Name.Block.Inventory.Button.PurchaseV2:
                case Name.Block.Inventory.Button.PurchaseV3:
                    const buttonType = InventoryCTAButtonType.fromBlockConfig(d);
                    switch (buttonType) {
                        case InventoryCTAButtonType.Inquire:
                            return { onButtonClick: props.onInquire }
                        case InventoryCTAButtonType.Offer:
                            return { onButtonClick: props.onOffer }
                        case InventoryCTAButtonType.Purchase:
                            return { onButtonClick: props.onPurchase }
                    }
                    break;
                case Name.Block.Inventory.Cell.Image:
                    return { backgroundColor: Layout.backgroundColorV2(props, containerProps), transforms, type: props.cellType };
                case Name.Block.Inventory.Cell.SlideshowImage:
                    return { backgroundColor: Layout.backgroundColorV2(props, containerProps), transforms, v3: true };
            }
        },
        builderBlockPropsHandler
    );

    let style, topHiddenOffset;
    if (containerProps && containerProps.config) {
        style = {};

        let configProps;
        for (let configName in containerProps.config) {
            configProps = containerProps.config[configName];
            Block.mapStyleConfigProps(style, configProps, (propName, propValue) => {
                switch (propName) {
                    case 'borderRadius':
                        if (propValue) {
                            style.overflow = 'hidden';
                        }
                        break;
                    case 'borderColor':
                    case 'borderWidth':
                        if (propValue) {
                            style.borderStyle = 'solid';
                        }
                        break;
                    case 'paddingTop':
                        topHiddenOffset = propValue;
                        break;
                }
            });
        }
    }
    const columnSpacing = Layout.columnSpacing(props.index, props.columnCount, props.columnSpacing);
    if (columnSpacing) {
        if (!style) {
            style = {};
        }
        style.marginLeft = columnSpacing.left;
        style.marginRight = columnSpacing.right;
    }
    let shouldUseLineSpacing = false;
    if (props.listData) {
        shouldUseLineSpacing = Layout.shouldUseLineSpacing(props.index, props.listData.length, props.columnCount);
        if (props.lineSpacing) {
            if (shouldUseLineSpacing) {
                if (!style) {
                    style = {};
                }
                style.marginBottom = props.lineSpacing;
            }
        }
    }
    if (props.cellType == 'grid') {
        if (!style) {
            style = {};
        }
        if (shouldUseLineSpacing) {
            style.height = `calc(100% - ${style.marginBottom || '36px'})`;
        } else {
            style.height = '100%';
        }
    }
    if (props.builder) {
        className += ' builder';
        if (props.editor) {
            className += ' builder-editor'
            if (props.parentBlock && props.parentBlock.config && props.parentBlock.config.block) {
                if (!style) {
                    style = {};
                }
                if (props.parentBlock.config.block.maxHeightSlideshow && props.parentBlock.config.block.maxHeightSlideshow.value && props.parentBlock.config.block.maxHeightSlideshow.unit) {
                    style.maxHeight = `${props.parentBlock.config.block.maxHeightSlideshow.value}${props.parentBlock.config.block.maxHeightSlideshow.unit}`;
                }
                if (props.parentBlock.config.block.minHeightSlideshow && props.parentBlock.config.block.minHeightSlideshow.value && props.parentBlock.config.block.minHeightSlideshow.unit) {
                    style.minHeight = `${props.parentBlock.config.block.minHeightSlideshow.value}${props.parentBlock.config.block.minHeightSlideshow.unit}`;
                }
            }
            if ((!style || !style.backgroundColor) && props.backgroundColor) {
                if (!style) {
                    style = {};
                }
                style.backgroundColor = props.backgroundColor;
            }
        }
        if (props.dragging) {
            className += ' dragging';
        }
    } else if (props.blockConfig && props.blockConfig.block) {
        switch (parseInt(props.blockConfig.block.detailDisplay, 10)) {
            case 0:
                // Modal
                renderedBlocks = (
                    <div id={props.data.id} style={{ cursor: 'pointer', display: 'inline' }} onClick={props.onModalOpen}>
                        {renderedBlocks}
                    </div>
                );
                break;
            default:
                const link = Url.getLink('', `art/${props.data.inventoryId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
                renderedBlocks = (
                    <a href={link}>
                        {renderedBlocks}
                    </a>
                );
                break;
        }
    }
    let content = (
        <React.Fragment>
            {
                props.editor &&
                <PageTopHiddenDraggable offset={topHiddenOffset} pageEmpty={!renderedBlocks || renderedBlocks.length == 0} onDragEnter={props.onDragEnter} />
            }
            {renderedBlocks}
            {
                props.editor &&
                <PageBottomHiddenDraggable onDragEnter={props.onDragEnter} />
            }
        </React.Fragment>
    );
    const contentProps = {
        className: className,
        id: props.id,
        style: style,
        onDragOver: (e) => { if (e) { e.preventDefault() } },
        onDrop: props.onDrop
    }
    if (props.editor) {
        return <EditorContainerWrapper {...contentProps}>{content}</EditorContainerWrapper>
    }
    content = <div {...contentProps}>{content}</div>
    switch (props.animation) {
        case '1':
            content = <Animation active={props.active} builder={props.builder}>{content}</Animation>
            break;
    }
    return content;
}
const InventoryCellContainer = withBlockRendering(_InventoryCellContainer);

// #region INVENTORY IMAGE

function _InventoryImageComponent(props) {
    const inventory = props.data || {};
    let _image;
    if (inventory.images && inventory.images.length > 0) {
        _image = inventory.images[0];
    }
    let imageData = {};
    if (inventory.seo) {
        imageData = {
            alt: inventory.seo.imageAlt,
            caption: inventory.seo.imageCaption,
            description: inventory.seo.imageDescription,
            title: inventory.seo.imageTitle
        };
    }
    const backgroundColor = (Utilities.rgbaToHex(props.backgroundColor).hex || '').replace('#', '');
    const style = { fontSize: 0, lineHeight: 1, textAlign: 'center' };
    switch (props.type) {
        case 'slideshow':
            if (!props.v3) {
                let imageStyle;
                if (props.builder) {
                    style.height = '100%';
                } else if (!props.config.canDownloadImages) {
                    imageStyle = { pointerEvents: 'none' };
                }
                if (props.blockConfig && props.blockConfig.layout) {
                    Block.mapStyleConfigProps(style, props.blockConfig.layout);
                }
                const imageUrl = Image.url(
                    _image,
                    undefined,
                    1024,
                    undefined,
                    undefined,
                    backgroundColor
                );
                return (
                    <div className="slider__img" style={style}>
                        {
                            imageUrl &&
                            <img src={imageUrl} style={imageStyle} {...imageData} />
                        }
                        {
                            props.editor &&
                            !imageUrl &&
                            <EmptyPlaceholder />
                        }
                    </div>
                );
            }
        // Intentional fallthrough
        default:
            const [hoverImageTuples, setHoverImageTuples] = React.useState(undefined);
            const [imageTuples, setImageTuples] = React.useState(undefined);
            const generateHoverImageTuples = () => {
                if (!props.blockConfig || !props.blockConfig.layout || !props.blockConfig.layout.showHoverImage) {
                    setHoverImageTuples(undefined);
                    setHoverImageVisible(false);
                    return;
                }
                if (!inventory.images || inventory.images.length < 2) {
                    return;
                }
                setHoverImageTuples(_generateImageTuples(inventory.images[1]));
            }
            const generateImageTuples = () => setImageTuples(_generateImageTuples(_image))
            const _generateImageTuples = (image) => {
                if (!image || props.v3) {
                    return;
                }
                const tuples = Image.sizes.map(function (d) {
                    let url;
                    if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.isCropped == true) {
                        url = Image.url(image, d, d, 'c_fill');
                    } else {
                        url = Image.url(
                            image,
                            props.type == 'waterfall' ? undefined : d,
                            d,
                            props.transforms || 'c_pad',
                            undefined,
                            backgroundColor
                        );
                    }
                    return { size: d, url };
                });
                return tuples;
            }
            React.useEffect(() => {
                generateImageTuples();
                generateHoverImageTuples();
            }, []);
            React.useEffect(() => {
                generateImageTuples();
                generateHoverImageTuples();
            }, [props.blockConfig.layout.isCropped, props.backgroundColor]);

            const [hoverImageVisible, setHoverImageVisible] = React.useState(false);
            const handleMouseEnter = React.useCallback(() => {
                if (!hoverImageTuples) {
                    return;
                }
                setHoverImageVisible(true);
            }, [hoverImageTuples]);
            const handleMouseLeave = React.useCallback(() => {
                if (!hoverImageTuples) {
                    return;
                }
                setHoverImageVisible(false);
            }, [hoverImageTuples]);

            let hasMaxHeight = false;
            let isCropped = false;
            if (props.blockConfig && props.blockConfig.layout) {
                Block.mapStyleConfigProps(style, props.blockConfig.layout, (propName, propValue) => {
                    switch (propName) {
                        case 'alignItems':
                            if (!props.builder) {
                                style.margin = Block.marginForAlignment(propValue);
                            }
                            return true;
                        case 'alignment':
                            switch (propValue) {
                                case 'tl':
                                    style.alignItems = 'flex-start';
                                    style.justifyContent = 'flex-start';
                                    break;
                                case 'tc':
                                    style.alignItems = 'flex-start';
                                    style.justifyContent = 'center';
                                    break;
                                case 'tr':
                                    style.alignItems = 'flex-start';
                                    style.justifyContent = 'flex-end';
                                    break;
                                case 'ml':
                                    style.alignItems = 'center';
                                    style.justifyContent = 'flex-start';
                                    break;
                                case 'mc':
                                    style.alignItems = 'center';
                                    style.justifyContent = 'center';
                                    break;
                                case 'mr':
                                    style.alignItems = 'center';
                                    style.justifyContent = 'flex-end';
                                    break;
                                case 'bl':
                                    style.alignItems = 'flex-end';
                                    style.justifyContent = 'flex-start';
                                    break;
                                case 'bc':
                                    style.alignItems = 'flex-end';
                                    style.justifyContent = 'center';
                                    break;
                                case 'br':
                                    style.alignItems = 'flex-end';
                                    style.justifyContent = 'flex-end';
                                    break;
                            }
                            return true;
                        case 'height':
                            return props.builder;
                        case 'maxHeight':
                            hasMaxHeight = propValue.length > 0;
                            return props.builder;
                        case 'isCropped':
                            isCropped = propValue;
                            return true;
                        case 'hoverColor':
                        case 'hoverEffect':
                        case 'hoverScale':
                        case 'hoverZoom':
                        case 'showHoverImage':
                            return true;
                        case 'width':
                            return props.builder;
                    }
                });
            }
            let imageStyle = {};
            if (hasMaxHeight) {
                imageStyle = { height: 'auto', maxHeight: '100%', maxWidth: '100%', width: 'auto' }
                style.height = '100%';
            } else if (props.builder) {
                imageStyle = { maxHeight: '100%' }
            }
            if (!props.builder && !props.config.canDownloadImages) {
                imageStyle.pointerEvents = 'none';
            }
            Utilities.copyObject(props.hoverImageStyle, imageStyle);

            let hoverTupleImageStyle, tupleImageStyle;
            if (imageTuples && hoverImageTuples) {
                hoverTupleImageStyle = { height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' };
                Utilities.copyObject(props.hoverImageStyle, hoverTupleImageStyle);

                tupleImageStyle = { ...imageStyle, position: 'relative' };
                tupleImageStyle.opacity = hoverImageVisible ? '0' : '1';
                tupleImageStyle.transition = `opacity 400ms ease-in-out`;
            }
            let image;
            if (imageTuples) {
                image = (
                    <>
                        {
                            !hoverImageTuples ?
                                <ImageSrcSet
                                    builder={props.builder}
                                    config={props.config}
                                    data={imageData}
                                    imageTuples={imageTuples}
                                    style={imageStyle} />
                                :
                                <div style={{ position: 'relative' }}>
                                    <ImageSrcSet
                                        builder={props.builder}
                                        config={props.config}
                                        data={imageData}
                                        imageId={`${_image.id}-hover`}
                                        imageTuples={hoverImageTuples}
                                        style={hoverTupleImageStyle} />
                                    <ImageSrcSet
                                        builder={props.builder}
                                        config={props.config}
                                        data={imageData}
                                        imageTuples={imageTuples}
                                        style={tupleImageStyle} />
                                </div>
                        }
                    </>
                )
            }
            if (!props.builder && props.hoverEffectVisible) {
                image = <span style={props.hoverStyle} onMouseEnter={props.onHoverStart} onMouseLeave={props.onHoverEnd}>{image}{props.hoverEffect}</span>
            }
            return (
                <div className="aw__item__img" style={style} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    {
                        props.v3 &&
                        <img {...imageData} style={imageStyle} src={Image.url(
                            _image,
                            isCropped ? 1024 : undefined,
                            1024,
                            isCropped ? 'c_fill' : undefined,
                            undefined,
                            backgroundColor
                        )} />
                    }
                    {image}
                    {
                        props.editor &&
                        !imageTuples &&
                        <EmptyPlaceholder />
                    }
                </div>
            );
    }
}
const InventoryImageComponent = withHoverEffects(_InventoryImageComponent, 'layout');
const InventoryImage = { Component: InventoryImageComponent };

// #endregion INVENTORY IMAGE

// #region INVENTORY META

function InventoryMetaComponent(props) {
    const inventory = props.data || {};
    const edition = InventoryHelper.edition(inventory) || {};
    const handleTokenReplacement = (keyword, options) => Token.parsing.inventory({ edition, inventory, isArtist: props.isArtist }, keyword, options);
    return <Meta {...props} onTokenReplacement={handleTokenReplacement} />
}
const InventoryMetaTokens = () => {
    return [
        Token.getWrappedTokenConfig('Artist Name', Token.ArtistName),
        Token.getWrappedTokenConfig('Artist Lifespan', Token.ArtistLifespan),
        Token.getWrappedTokenConfig('Title', Token.Title),
        Token.getWrappedTokenConfig('Edition Info', Token.Edition),
        Token.getWrappedTokenConfig('Created Date', Token.Date),
        Token.getWrappedTokenConfig('Medium', Token.Medium),
        Token.getWrappedTokenConfig('Dimensions', Token.Dimensions),
        Token.getWrappedTokenConfig('Alternate Dimensions', Token.AlternateDimensions),
        Token.getWrappedTokenConfig('Framing Dimensions', Token.Framing),
        Token.getWrappedTokenConfig('Inventory Number', Token.InventoryNumber),
        Token.getWrappedTokenConfig('SKU', Token.SKU),
        Token.getWrappedTokenConfig('Quantity', Token.Quantity),
        Token.getPriceTokenConfig(),
        Token.getPriceTokenConfig({ display: 'Price With Tax', token: Token.PriceWithTax }),
        Token.getAlternatePricesTokenConfig(),
        {
            display: 'Framed',
            options: [{ display: 'Display Text', name: 'display' }],
            token: Token.Framed
        },
        {
            display: 'Unframed',
            options: [{ display: 'Display Text', name: 'display' }],
            token: Token.Unframed
        },
        Token.getWrappedTokenConfig('Mounting', Token.Mounting),
        Token.getWrappedTokenConfig('Location', Token.Location),
        {
            display: 'Sold',
            options: [{ display: 'Display Text', name: 'display' }],
            token: Token.Sold
        },
        Token.getStatusIndicatorTokenConfig(Token.StatusIndicator)
    ];
}
const InventoryMeta = { Component: InventoryMetaComponent, Tokens: InventoryMetaTokens };

// #endregion INVENTORY META

export {
    InventoryCellContainer,
    InventoryImage,
    InventoryMeta
}